function getTaskTypeDisplay(taskType) {
  return this.taskTypeList[taskType] || taskType;
}

export default {
  data() {
    return {
      taskTypeList: {
        merge: "合并文件",
        copy: "拷贝文件",
        merge_continus: "叠拼",
        merge_stacked: "合拼",
        merge_onebyone: "合并封面",
        merge_sewing: "锁线"
      }
    };
  },
  methods: {
    getTaskTypeDisplay
  }
};
